import { styled } from '../../../../../../../../../core/theme/styled';

export const StyledAccountSelectionContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: center;
  padding: 0 ${(props) => props.theme.sizes.xxlarge};
`;

type StyledAccountSelectionText = {
  semiBold?: boolean;
};

export const StyledAccountSelectionText = styled.div<StyledAccountSelectionText>`
  line-height: ${(props) => props.theme.sizes.normedium};
  margin-bottom: ${(props) => (props.semiBold ? props.theme.sizes.xsmall : 0)};
  font-weight: ${(props) =>
    props.semiBold ? props.theme.font.weights.semiBold : props.theme.font.weights.regular};
  color: ${(props) => props.theme.configuration.primaryTextColor};
`;
